import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import selectors from "rdx/modules/settings/selectors";
import messages from "rdx/modules/settings/messages";

function* removeAdminBatteryServiceArea(action) {
  const { success, data, error } = yield* makeRequest.delete(
    `/battery_service_areas/${action.payload.state}`,
    action.payload,
  );

  if (success && data) {
    const serviceAreas = yield select(selectors.getAdminBatteryServiceAreas);
    const out = serviceAreas.slice().filter((s) => s.state !== action.payload.state);
    yield all([
      put(actions.setAdminBatteryServiceAreas(out)),
      put(
        actions.newSuccessEvent({
          message: messages.BATTERY_SERVICE_AREA_REMOVE_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_REMOVING_BATTERY_SERVICE_AREA,
    });
  }

  return null;
}

export default removeAdminBatteryServiceArea;
